var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLetsQuiz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "currentColor",
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.164 10.64 2.758-.007a3.716 3.716 0 0 1-.024-.516c0-1.21.93-1.43 1.68-2.172.813-.78 1.078-1.5 1.078-2.718 0-1.485-1.562-3.32-3.953-3.32-2.406 0-3.14 1.35-3.367 1.741l1.039 2.22c.336-.774 1.195-1.313 2.164-1.313.906 0 1.445.437 1.445 1.218 0 .454-.296.844-.601 1.063-1.453 1.07-2.235 1.992-2.235 3.406 0 .235 0 .313.016.399Zm1.399 4.782c.976 0 1.789-.75 1.789-1.688 0-.937-.813-1.734-1.805-1.734-.969 0-1.766.758-1.766 1.695 0 .938.782 1.727 1.782 1.727Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetsQuiz);
export default __webpack_public_path__ + "static/media/LetsQuiz.0b0518df00920e7a9e520b16bb6b855a.svg";
export { ForwardRef as ReactComponent };